import { fetchOrders } from 'actions/OrderActions'
import type { AppAction } from 'actions/types/ActionTypes'
import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import { haveOrdersBeenFetched } from 'lib/order/orderUtils'
import { shouldFetchOrdersForAgentHubBookingOnboarding } from './canStartAgentHubBookingOnboarding'
import { getAgentHubBookingOnboardingStatus } from './agentHubBookingOnboardingStorage'

const UPCOMING_ORDER_LIST = 'upcoming' as const

export function fetchUpcomingOrdersForAgentHubBookingOnboarding(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const memberId = state.auth.account.memberId

    if (!shouldFetchOrdersForAgentHubBookingOnboarding({
      haveOrdersBeenFetched: haveOrdersBeenFetched(state, UPCOMING_ORDER_LIST),
      isAgentHubEnabled,
      isHomepage: true,
      isLoggedIn: !!memberId,
      memberId,
      storedStatus: memberId ? getAgentHubBookingOnboardingStatus(memberId) : undefined,
    })) {
      return
    }

    dispatch(fetchOrders({ status: UPCOMING_ORDER_LIST }))
  }
}
